import React, { useMemo } from 'react';
import MetricCard from '@/pages/dashboard/components/MetricCardItem/MetricCard';
import { IMetricCardProps } from '@/pages/home/pages/studio/type';
import './index.scss';
import { JumpType } from '@home/utils/utils';

const KeyMetricsCard = (props: IMetricCardProps) => {
  const { metric, keyMetricsData, gameCode } = props;

  const { metricsData, keyMetricsTrend, xAxisData, trendData, componentMetrics, mainMetricsList, jumpUrl, jumpType, haveJump} = useMemo(() => {
    const { card_list: metricsData = [], trend_list: keyMetricsTrend = [] } = keyMetricsData || {};
    const { metricKey, titleEn, titleCn, jumpUrl, jumpType = JumpType.Window, haveJump } = metric || {};
    const componentMetrics = [{
      ...metric,
      enName: titleEn,
      cnName: titleCn,
    }];
    const mainMetricsList = [metricKey];
    const trendData: { [key: string]: Array<string[]>; } = {};
    const xAxisData = keyMetricsTrend?.map((item) => item?.date);
    if (keyMetricsTrend && metricKey) {
      const currentList: string[] = [];
      const lastList: string[] = [];
      keyMetricsTrend?.forEach((item) => {
        currentList?.push(item?.metrics?.[metricKey]?.value);
        lastList?.push(item?.metrics?.[metricKey]?.last_value);
      });
      trendData[metricKey] = [currentList, lastList];
    }
    return {
      metricsData,
      keyMetricsTrend,
      xAxisData,
      trendData,
      componentMetrics,
      mainMetricsList,
      jumpUrl,
      jumpType,
      haveJump,
    };
  }, [keyMetricsData, metric]);

  return <div className='dbh-key-metrics-card' >
    <MetricCard
      config={{
        componentMetrics,
        jumpUrl,
        jumpType,
      }}
      data={{
        mainMetricsList,
        haveJump
      }}
      dateDimension={'DAY'}
      isChange={false}
      metricsData={metricsData}
      trendData={trendData}
      xAxisData={xAxisData}
      keyMetricsTrend={keyMetricsTrend}
      gameCode={gameCode}
    />
  </div>;
};

export default KeyMetricsCard;